import { type NavbarDataProps, setActiveItem } from '@/hooks/useNavbarItems';
import { gunterzBold } from '@/theme/fonts';
import { Box, Text, Timeline } from '@mantine/core';
import { useListState } from '@mantine/hooks';
import Link from 'next/link';
import classes from './NavbarSubItem.module.css';
export type NavbarSubItemProps = {
  label: string;
  data: NavbarDataProps[];
};
export const NavbarSubItem: React.FC<NavbarSubItemProps> = ({
  label,
  data
}) => {
  const [values, handlers] = useListState(data);
  const handleChildItemClick = (path: string) => setActiveItem(handlers, path);
  return <Box py={{
    base: 15,
    lg: 0
  }}>
      <Text fz={15} tt="uppercase" fw={700} c="var(--mantine-color-prime-0)" className={gunterzBold.className} pb={15} hiddenFrom="lg">
        {label}
      </Text>
      <Timeline active={-1} bulletSize={8} lineWidth={1.5} classNames={classes} py={10}>
        {Object.values(values).map(item => <Timeline.Item key={item.label} mod={{
        active: item.active
      }} title={<Text tt="uppercase" {...item.onClick ? {
        onClick: () => {
          item.onClick?.();
          handleChildItemClick(item.href ?? '');
        },
        href: '#'
      } : {
        onClick: () => handleChildItemClick(item.href ?? ''),
        href: item.href ?? ''
      }} component={Link} fz={12} fw={700}>
                {item.label}
              </Text>} />)}
      </Timeline>
    </Box>;
};